import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DashboardLayout } from './components/DashboardLayout';
import { LandingPage } from './pages/LandingPage';
import { DashboardOverview } from './pages/DashboardOverview';
import { LearningHub } from './pages/LearningHub';
import { CareerPathways } from './pages/CareerPathways';
import { JobMarketplace } from './pages/JobMarketplace';
import { ImpactDashboard } from './pages/ImpactDashboard';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />

        <Route path="/dashboard" element={<DashboardLayout data-id="element-5" />} data-id="element-4">
          <Route index element={<DashboardOverview data-id="element-7" />} data-id="element-6" />
          <Route path="learning" element={<LearningHub data-id="element-9" />} data-id="element-8" />
          <Route path="career" element={<CareerPathways data-id="element-11" />} data-id="element-10" />
          <Route path="jobs" element={<JobMarketplace data-id="element-13" />} data-id="element-12" />
          <Route path="impact" element={<ImpactDashboard data-id="element-15" />} data-id="element-14" />
        </Route>

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-17" />} data-id="element-16" />
      </Routes>
    </BrowserRouter>;
}